export default {
  mounted(el, binding) {
    el._tooltip = new window.bootstrap.Tooltip(el, {
      title: binding.value,
      container: "#page-container",
      trigger: "hover",
    });
  },
  updated(el, binding) {
    if (binding.value !== binding.oldValue) {
      if (el._tooltip) {
        el._tooltip.dispose();
      }
      el._tooltip = new window.bootstrap.Tooltip(el, {
        title: binding.value,
        container: "#page-container",
        trigger: "hover",
      });
    }
  },
  beforeUnmount(el) {
    if (el._tooltip) {
      el._tooltip.dispose();
      delete el._tooltip;
    }
  },
};
